import * as React from 'react';
import { injectIntl, FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import { VerificationService } from '@sheerid/jslib';

interface StepStudentPersonalInfoProps {
    verificationService: VerificationService;
}

const StepStudentPersonalInfo = ({ verificationService }: StepStudentPersonalInfoProps) => {
    const errorTitle: FormattedMessage.Props =
        {
            id: 'returnToWSJ',
            defaultMessage: 'Please Return to Wall Street Journal Verification',
        };

    return (
        <div className="sid-step-error sid-l-container">
            <div className="sid-header sid-l-horz-center">
                <div className="sid-l-horz-center">
                    <img
                        className="sid-l-lead-image"
                        alt="design element"
                        src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-exclamation.svg"
                    />
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage {...errorTitle} />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-space-top-md">
                    <div className="sid-l-space-top-lg sid-l-half-width sid-l-horz-center">
                        <button
                            id="sid-step-error-button"
                            type="submit"
                            className={'sid-btn sid-btn--dark sid-l-full-width sid-button-add-link'}
                            aria-label="submit"
                            onClick={() => window.open('https://www.wsj.com/')}
                            >
                            <FormattedHTMLMessage
                                id="step.success.continueButton"
                                defaultMessage="Wall Street Journal"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const StepStudentPersonalInfoComponent = injectIntl(StepStudentPersonalInfo);
